import React from 'react';
import { cn } from '../../utils/cn';
import { ChevronDown } from 'lucide-react';

const StandardSelect = ({ 
  label,
  error,
  helperText,
  options = [],
  className,
  ...props 
}) => {
  const baseStyles = 'w-full px-4 py-3 min-h-[48px] pr-10 border rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-teal-500 disabled:bg-gray-100 disabled:cursor-not-allowed appearance-none bg-white';
  
  const stateStyles = error 
    ? 'border-red-500 focus:border-red-500' :'border-gray-300 focus:border-teal-500';
  
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        <select
          className={cn(
            baseStyles,
            stateStyles,
            className
          )}
          {...props}
        >
          {options?.map((option, index) => (
            <option key={index} value={option?.value}>
              {option?.label}
            </option>
          ))}
        </select>
        <ChevronDown 
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" 
          size={20} 
        />
      </div>
      {error && (
        <p className="mt-2 text-sm text-red-600">{error}</p>
      )}
      {helperText && !error && (
        <p className="mt-2 text-sm text-gray-500">{helperText}</p>
      )}
    </div>
  );
};

export default StandardSelect;